import React from 'react';

const UnreadCountBadge: React.FC<{ count: number; className?: string }> = ({ count, className = '' }) => {
  if (count <= 0) return null;
  return (
    <span
      className={`min-w-[20px] h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center px-1 font-medium ${className}`}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
};

export default UnreadCountBadge;
